
import { tryFind, ofList, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { LabelId } from "../../Shared/Shared.js";
import { Label } from "../../Shared/Category.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";

export function buildInspectionLookup(toolBoxData) {
    if (toolBoxData == null) {
        return empty({
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
    }
    else {
        return ofList(map((dto) => [dto.UserId, dto.HasUninspectedTools], toolBoxData), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
    }
}

export function inspectionStatusColumnDefinition(inspectionLookup, getId, t) {
    return new ColumnDefinition$1("inspectionStatus", "", t("toolbox.inspection_status"), (dto) => {
        const hasUninspected = defaultArg(tryFind(getId(dto), inspectionLookup), false);
        return new CellContent(3, [singleton(new Label(new LabelId("00000000-0000-0000-0000-000000000000"), hasUninspected ? t("toolbox.uninspected_tools") : t("toolbox.all_tools_inspected"), hasUninspected ? "#dc3545" : "#28a745", true, undefined))]);
    }, "select", "text");
}

